import React from 'react';
import styles from './SeccionesText.module.css';

const sections = [
  {
    title: "Sistemas y Dispositivos",
    content: (
      <>
        <h3>Terminales Multibiométricos / Biométricos</h3>
        <ul>
          <li>Reconocimiento Facial con y sin medición de temperatura</li>
          <li>Lectores de Huella, tarjeta, código</li>
        </ul>
        <h3>Software de Asistencia</h3>
        <ul>
          <li>Software on premise y on demand</li>
          <li>Plataformas propietarias de la marca</li>
          <li>Plataformas cloud: desarrollo propio</li>
          <li>Con sincronización e interface con otros ERP</li>
          <li>Sistemas stand alone o intercomunicados entre sí</li>
          <li>Con generación de geo-cercas y alarmas</li>
          <li>App para registros, marcación y gestión ubicación GPS</li>
        </ul>
        <h3>Barreras de Acceso Vehicular</h3>
        <ul>
          <li>Sistemas RFID: tarjeta</li>
          <li>Sistemas UHF: sticker en vehículo</li>
          <li>Sistemas QR: lectores QR</li>
          <li>Sistema ANPR: control de placas</li>
        </ul>
        <h3>Bolardos</h3>
        <ul>
          <li>Automáticos</li>
          <li>Semi automáticos</li>
        </ul>
        <h3>Software de Control</h3>
        <ul>
          <li>Control de tiempo: ingreso, salida</li>
          <li>Control usuario: visita, regular, empleado</li>
          <li>Gestión programada</li>
          <li>Reportes</li>
        </ul>
      </>
    ),
  },
  {
    title: "Soluciones",
    content: (
      <>
        <h3>Automatización de Puertas</h3>
        <ul>
          <li>Puertas doble hoja corredizas</li>
          <li>Puertas abatibles una hoja</li>
        </ul>
        <h3>Motores para Puertas</h3>
        <ul>
          <li>Corredizos</li>
          <li>Enrollables</li>
          <li>Abatibles</li>
          <li>Garage</li>
        </ul>
        <h3>Automatización de Ventanas</h3>
        <h3>Accesorios</h3>
        <ul>
          <li>Fotoceldas</li>
          <li>Garras de piso</li>
          <li>Kit de puerta telescópica</li>
          <li>Ruedas</li>
          <li>Creamallera</li>
          <li>Controles remoto</li>
        </ul>
      </>
    ),
  },
  {
    title: "Alarmas",
    content: (
      <ul>
        <li>Alarmas residenciales y oficinas</li>
        <li>Alarmas comunitarias</li>
        <li>Megafonía IP</li>
        <li>Electrificadores - Cercos Eléctricos</li>
      </ul>
    ),
  },
  {
    title: "Sistemas Contra Incendios",
    content: (
      <ul>
        <li>Convencionales</li>
        <li>Direccionables</li>
        <li>Estaciones manuales</li>
        <li>Sensores y detectores de humo y térmicos</li>
        <li>Luz estroboscópica</li>
        <li>Señalización</li>
      </ul>
    ),
  },
  {
    title: "Puertas de Seguridad y Especiales",
    content: (
      <>
        <h3>Puertas de Garage Residenciales</h3>
        <ul>
          <li>Seccionales</li>
        </ul>
      </>
    ),
  },
  {
    title: "Sistemas de Parqueo",
    content: (
      <ul>
        <li>Sistema de Cobro Centralizado</li>
        <li>Unidades de Entrada y Salida</li>
        <li>Sistema de Cobro Automático</li>
        <li>Sistema de Parqueo Inteligente: control de plazas</li>
        <li>Reconocimiento de Placas y Lectura Código QR</li>
        <li>Lectura Sticker Vehicular/código y tarjetas</li>
      </ul>
    ),
  },
  {
    title: "Puertas Corta Fuego",
    content: (
      <>
        <ul>
          <li>Puerta de Seguridad contra Incendios laminada</li>
          <li>Puerta de Seguridad cortafuego metálica</li>
        </ul>
        <h3>Puertas Comerciales e Industriales</h3>
        <ul>
          <li>Enrollables térmicas con aislamiento</li>
          <li>
            Puertas rápidas para uso muy intenso dotadas del especial e
            innovador sistema de autorreparación (industria alimenticia)
          </li>
        </ul>
      </>
    ),
  },
  {
    title: "Sistemas de Punto de Venta (POS)",
    content: (
      <ul>
        <li>Terminales Todo en Uno</li>
        <li>Periféricos: Impresoras Térmicas, Lectoras 1D, 2D</li>
        <li>Operación Omnicanal</li>
        <li>Administración de Inventarios</li>
        <li>Scáner</li>
        <li>Cajas de Dinero</li>
        <li>Tótems</li>
        <li>Antenas Anti Hurto</li>
      </ul>
    ),
  },
  {
    title: "Pantallas Interactivas, Publicitarias y Kioskos Digitales Touch",
    content: (
      <ul>
        <li>Pantallas Interactivas – OPS</li>
        <li>Sistemas Educativos – Aula Inteligente – Aulas híbridas</li>
        <li>Sistemas médicos: para anuncios publicitarios</li>
        <li>Pantallas y Monitores de Video</li>
        <li>Kioskos transaccionales</li>
        <li>Kioskos Publicitarios</li>
        <li>Turneros</li>
      </ul>
    ),
  },
  {
    title: "Networking – Redes – Telecomunicaciones",
    content: (
      <ul>
        <li>Switch</li>
        <li>Access Point</li>
        <li>Antenas</li>
        <li>Routers</li>
        <li>UPS</li>
        <li>Sistemas de Telefonía IP</li>
      </ul>
    ),
  },
  {
    title: "Soluciones para Pequeñas, Medianas y Grandes Empresas",
    content: (
      <ul>
        <li>Diseño e implementación de redes</li>
        <li>Switches: PoE, Administrables</li>
        <li>Access Point: Interiores/exteriores</li>
        <li>Radio Enlaces: punto a punto</li>
        <li>Servicio Garantía y Soporte personalizado</li>
        <li>Software</li>
        <li>Seguridad en Redes</li>
        <li>Servicios en la nube</li>
      </ul>
    ),
  },
  {
    title: "Sistemas de Salud",
    content: (
      <ul>
        <li>Registro de Pacientes</li>
        <li>Punto de Atención</li>
        <li>Tecnología de la información Médica</li>
        <li>Identificación de Muestras</li>
        <li>Automatización de Farmacias</li>
        <li>Seguimientos de Activos del cuidado de la salud</li>
      </ul>
    ),
  },
  {
    title: "Soluciones para Hospitales y Laboratorios",
    content: (
      <ul>
        <li>Registro de Pacientes</li>
        <li>Punto de Atención</li>
        <li>Tecnología de la información Médica</li>
        <li>Identificación de Muestras</li>
        <li>Automatización de Farmacias</li>
        <li>Seguimientos de Activos del cuidado de la salud</li>
      </ul>
    ),
  },
];

const SeccionesText = () => {
  return (
    <div className={styles.root}>
      {sections.map((section, index) => (
        <section
          key={index}
          className={`${styles.section} ${
            index % 2 === 0 ? styles.left : styles.right
          }`}
        >
          <h2>{section.title}</h2>
          {section.content}
        </section>
      ))}
    </div>
  );
};

export default SeccionesText;
